export function DocumentQuestionIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.2271 9.75V7.32C18.2271 5.80786 18.2271 5.05179 17.9363 4.47423C17.6806 3.96619 17.2725 3.55314 16.7706 3.29428C16.1999 3 15.4529 3 13.959 3H8.26812C6.77414 3 6.02715 3 5.45652 3.29428C4.95459 3.55314 4.5465 3.96619 4.29075 4.47423C4 5.05179 4 5.80786 4 7.32V16.68C4 18.1921 4 18.9482 4.29075 19.5258C4.5465 20.0338 4.95459 20.4469 5.45652 20.7057C6.02715 21 6.77414 21 8.26812 21H12.8919M12.8919 11.1H7.55677M9.33515 14.7H7.55677M14.6703 7.5H7.55677M15.1149 14.702C15.2716 14.2512 15.5808 13.8711 15.9879 13.629C16.3949 13.3869 16.8735 13.2983 17.3388 13.3791C17.8041 13.4599 18.2262 13.7048 18.5302 14.0704C18.8343 14.4359 19.0007 14.8986 19 15.3765C19 16.7255 17.0008 17.4 17.0008 17.4M17.0266 20.1H17.0355"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
